import styled from "styled-components";
import { screenSizes } from "../../constants/breakpoints";


export const TableContainer = styled.div`
    display: flex;
    flex-flow: column;
    max-width: 990px;
`
export const TableHead = styled.div`
    display: flex;
    padding: 16px;
    background: ${props => props.theme.borderColor};
    gap: 114px;
    border-radius: 5px;
`

export const TableBody = styled.div`
    display: flex;
    flex-flow: column;
`
export const TableRow = styled.div`
    display: flex;
    gap: 114px;
    padding: 28px 16px 43px 16px;
    border-bottom: 1px solid ${props => props.theme.borderColor};

`

export const TableData = styled.td`
    @media (min-width: ${screenSizes.mediaXXL}px) {
        p {
            font-size: 14px;
        }
    }
`